import { io, Socket } from 'socket.io-client';
import { getAuthToken } from '../api/client';
import { WS_BASE } from './wsBase';

let socket: Socket | null = null;

// Сокет общей live-ленты (namespace /live), через тот же Vite-прокси /socket.io.
export function getLiveSocket(): Socket {
  if (socket && socket.connected) return socket;
  if (!socket) {
    socket = io(WS_BASE + '/live', { auth: { token: getAuthToken() || '' } });
  } else {
    socket.auth = { token: getAuthToken() || '' };
    socket.connect();
  }
  return socket;
}
